import axios from 'axios';
import { TokenService } from '../services/token.service';
import store from '../store';

const ApiService = {
  init (baseURL) {
    axios.defaults.baseURL = baseURL;
  },

  _401Interceptor: null,

  async setHeader () {
    axios.defaults.headers.common['Authorization'] = `${TokenService.getToken()}`;
  },

  getHeader () {
    return axios.defaults.headers.common['Authorization'];
  },

  removeHeader () {
    axios.defaults.headers.common = {};
  },

  getEndpoint (url) {
    return axios.defaults.baseURL + url;
  },

  addQueryParams (url, params) {
    if (typeof params === 'object') {
      let size = Object.keys(params).length;
      let cont = 0;
      url = url.substr(url.length - 1) === '?' ? url : url + '?';
      for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
          url += key + '=' + params[key];
          url = size !== cont + 1 ? url + '&' : url;
          cont++;
        }
      }
    }
    return url;
  },

  async get (resource, config) {
    return axios.get(resource, config);
  },

  post (resource, data, config) {
    return axios.post(resource, data, config);
  },

  put (resource, data, config) {
    return axios.put(resource, data, config);
  },

  delete (resource, config) {
    return axios.delete(resource, config);
  },

  customRequest (request, config) {
    return axios(request, config);
  },

  mount401Interceptor () {
    this._401Interceptor = axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        // Handle error
        if (error.request.status === 401) {
          TokenService.setTokenValidValue(false);
          store.commit('user/setUserAuthError', {
            isError: true,
            authErrorMessage: 'Tu sesión expiró. Vuelve a identificarte'
          });

          store.dispatch('auth/logout');
        } else {
          // If error is not 401
          console.log('another than 401');
          throw error;
        }
      }
    );
  },

  unmount401Interceptor () {
    // Eject the interceptor
    axios.interceptors.response.eject(this._401Interceptor);
  }
};

export default ApiService;
